export { default } from "./useRedirectToReadPageIfContentDoesNotExist";
